import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import DocumentTitleSync from './jsx/components/DocumentTitleSync';
import SeoHead from './jsx/components/SeoHead';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import {Provider} from 'react-redux';
import {store} from './store/store';
import  ThemeContext  from "./context/ThemeContext"; 
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalconfig';

const msalInstance = new PublicClientApplication(msalConfig);

const clientId = '959324442212-1d3au5tkqtcqt926ibj2s4j59hidq4jl.apps.googleusercontent.com';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store = {store}>
      <HelmetProvider>
        <BrowserRouter>
          <SeoHead />
          <DocumentTitleSync />
          <ThemeContext>
          <GoogleOAuthProvider clientId={clientId}>
          <MsalProvider instance={msalInstance}>
            <App />
            </MsalProvider>
            </GoogleOAuthProvider>
          </ThemeContext>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
